var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"max-w-7xl mx-auto",class:{ isNoticeHead: !_vm.$store.state.isIndexTopNotice, mainBody: _vm.$store.state.isIndexTopMainBody }},[_c('router-view')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }